import React from 'react';
import { BONUS_KICKER, BONUS_TOTAL, bonuses } from '../data/eatWellContent';
export function BonusesSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="bonuses-title" data-id="element-19" data-mp="gwx5x4ldv9es">
      <div className="mx-auto max-w-6xl px-5" data-id="element-20" data-mp="vuh49snry6bz">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-21" data-mp="qu2w8am6awdy">
          Always included
        </p>
        <h2 id="bonuses-title" className="mt-3 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-22" data-mp="14rzvxfvxbiwu">
          5 Strategic bonuses
        </h2>
        <p className="mt-3 text-center text-[14px] leading-snug text-body" data-id="element-23" data-mp="1el8d8t3unupu">
          {BONUS_KICKER}
        </p>

        <ul className="mt-8 grid gap-x-4 gap-y-8 sm:grid-cols-3 lg:grid-cols-5" data-id="element-24" data-mp="1nk26qalvw4z6">
          {bonuses.map(b => <li key={b.number} className="flex flex-col text-center" data-id="element-25" data-mp="1jj0e4cmh2r66">
              <img src={b.image} alt={`${b.title} — official EAT WELL IN 20 bonus cover`} className="mx-auto w-full max-w-[11rem]" width={1080} height={1350} data-id="element-26" data-mp="1jgnoreedxej3" />
              <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-27" data-mp="2kuj4hs91r6w">
                Bonus {b.number}
              </p>
              <h3 className="mt-1 font-display text-base font-semibold uppercase leading-tight text-ivory-50" data-id="element-28" data-mp="cjs45aqgv2l5">
                {b.title}
              </h3>
              <p className="mx-auto mt-1.5 max-w-[15rem] text-[13px] leading-snug text-body" data-id="element-29" data-mp="gju9puzbog5p">
                {b.line}
              </p>
              <p className="mt-auto pt-2 text-[10px] font-semibold uppercase tracking-[0.16em]" data-id="element-30" data-mp="qb6zmh1k8w93">
                <span className="text-muted line-through" data-id="element-31" data-mp="va9ux9rqno3v">{b.value} USD</span>
                <span className="ml-2 text-champagne" data-id="element-32" data-mp="v86udvsymckw">Free</span>
              </p>
            </li>)}
        </ul>

        <p className="mt-10 border-y border-champagne/25 py-5 text-center text-[13px] font-semibold uppercase tracking-[0.18em] text-ivory-100" data-id="element-33" data-mp="al8ol2wiy5gf">
          Total bonus value <span className="text-muted line-through" data-id="element-34" data-mp="5np77u4j5ck9">{BONUS_TOTAL}</span>
          <span className="ml-3 text-champagne" data-id="element-35" data-mp="kc3lr2bb6pgn">→ Free with your Eat Well in 20™</span>
        </p>
      </div>
    </section>;
}